import React, { useEffect, useState } from 'react'
import { useAuth } from '../../AuthContext'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import './profile.css'

const apiUrl = process.env.REACT_APP_API_URL

const Profile = () => {
    const [error, setError] = useState(null)
    const { user, setUser, isLoggedIn, statusReady, accounts, setAccounts } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (statusReady && !isLoggedIn) navigate('/login')
    }, [isLoggedIn, statusReady, navigate])

    const deleteAccount = async (id) => {
        try {
            await axios.delete(
                `${apiUrl}/delete_google_creds`,
                {
                    data: { account_id: id },
                    withCredentials: true
                }
            )
            setAccounts(accounts.filter((account) => account.id !== id))
        } catch (error) {
            console.error(error)
            setError(error.response?.data?.message || 'Error deleting account')
        }
    }

    const cancelSub = async () => {
        try {
            const response = await axios.put(
                `${apiUrl}/cancel_sub`,
                {},
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
            setUser(response.data)
        } catch (error) {
            console.error(error)
            setError(error.response?.data?.message || 'Error canceling subscription')
        }
    }

    return (
        <div className="profile-container">
            <div className="profile-card">
                <div className="profile-header">
                    <div className="avatar">{user?.username ? user.username.charAt(0).toUpperCase() : 'U'}</div>
                    <div className="header-info">
                        <h1>{user?.username || 'User'}</h1>
                        <p className="email">{user?.email}</p>
                    </div>
                </div>

                <div className="profile-body">
                    <div className="info-row">
                        <div className="label">Tokens</div>
                        <div className="value"><span className="badge token-badge">{user?.tokens ?? 0}</span></div>
                    </div>

                    <div className="info-row">
                        <div className="label">Subscription Plan</div>
                        <div className="value"><span className="chip">{user?.subscription_plan || '—'}</span></div>
                    </div>

                    <div className="info-row">
                        <div className="label">Subscription Status</div>
                        <div className="value"><span className={`chip status ${user?.subscription_status || ''}`}>{user?.subscription_status || 'none'}</span></div>
                    </div>

                    {accounts.length > 0 && (
                        <div className="accounts">
                            <h3>Google Accounts</h3>
                            <ul className="account-list">
                                {accounts.map((account) => (
                                    <li key={account.id} className="account-item">
                                        <span className="account-email">{account.google_email}</span>
                                        <button className="remove-account-btn" onClick={() => deleteAccount(account.id)}>Remove</button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {user?.subscription_status === 'active' && (
                        <button className="cancel-sub-btn" onClick={cancelSub}>
                            Cancel Subscription
                        </button>
                    )}

                    {error && <div className="error">{error}</div>}
                </div>
            </div>

        </div>
    )
}

export default Profile
